import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'todo-ui', {
    editTodoList: 'Edit todo list',
    trashTodoList: 'Trash todo list',
    trashTodo: 'Trash todo',
    todoDeleted: 'Todo deleted',
    noTodoListsYet: 'No todo lists yet. Use the button below to create one.',
    newTodo: 'New todo',
    newList: 'New list',
    todoListRenamed: 'Todo list renamed',
    todoListDeleted: 'Todo list deleted',
    todoListRestoreFailed: 'Could not restore the todo list',
    noMatchingItems: 'No matching items',
    empty: 'Empty',
    createTodoListFirst: 'Create a todo list first',
    newTodoCreated: 'New todo created',
    newTodoListCreated: 'New todo list created',
  });
}
